import React, { Component } from "react";
import { connect } from "react-redux";
import {
    get as loadClock,
    getEmployees as loadEmployees,
    getEvents as loadEvents
} from "../../reducer/actions";
import { Button, Dimmer, Header, Icon, Loader, Segment } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import { getActivities, getEmployees, getEvents, isLoading } from "../../reducer";
import WarehouseSelect from "../../components/WarehouseSelect";
import Schedule from "../Schedule";
import BigCalendar from "react-big-calendar";
import moment from "moment";

import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = BigCalendar.momentLocalizer(moment);



const activityColors = {
    1: "#247BA0",
    2: "#70C1B3",
    3: "#B2DBBF",
    4: "#6CC551",
    5: "#487B72",
    6: "#174F66",
    7: "#FF1654",
    8: "#FFAAC0",
};


class ScheduleView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "week",
            warehouse_id: null,
            loaded_warehouse_id: null,
            minTime: moment({
                hour: 6,
                minute: 0
            })
                .toDate(),
            dayChosen: new Date(),
            events: [],
            minDate: moment()
                .subtract(1, "month")
                .startOf("month")
                .toDate(),
            maxDate: moment()
                .add(1, "month")
                .endOf("month")
                .toDate(),
            loaded: false
        };

    }

    reloadEvents() {
        return new Promise((resolve) => {
            this.props.loadEvents(this.state.warehouse_id, moment(this.state.minDate)
                .format("X"), moment(this.state.maxDate)
                .format("X"))
                .then((events) => {
                    this.setState({
                        loaded_warehouse_id: this.state.warehouse_id,
                        loaded: true,
                        events: events.map((event) => {

                            event.start = moment(event.start)
                                .toDate();
                            event.end = moment(event.end)
                                .toDate();
                            event.title = Schedule.getEventTitle(event, this.props.activities, this.props.employees);
                            event.allDay = event.allDay === 1;

                            return event;
                        })
                    });
                    resolve();
                });
        });

    }


    moveEvent({ event, start, end, isAllDay: droppedOnAllDaySlot }) {
        const { events } = this.state;

        const idx = events.indexOf(event);
        let allDay = event.allDay;

        if (!event.allDay && droppedOnAllDaySlot) {
            allDay = true;
        } else if (event.allDay && !droppedOnAllDaySlot) {
            allDay = false;
        }

        const updatedEvent = {
            ...event,
            start,
            end,
            allDay
        };

        const nextEvents = [...events];
        nextEvents.splice(idx, 1, updatedEvent);

        this.setState({
            events: nextEvents,
        });

        // alert(`${event.title} was dropped onto ${updatedEvent.start}`)
    }

    resizeEvent({ event, start, end }) {
        console.log("in resize event", event);
        const { events } = this.state;

        const nextEvents = events.map(existingEvent => {
            return existingEvent.id === event.id
                ? {
                    ...existingEvent,
                    start,
                    end
                }
                : existingEvent;
        });

        this.setState({
            events: nextEvents,
        });

        //alert(`${event.title} was resized to ${start}-${end}`)
    }

    newEvent(event) {
        this.setState({
            newEvent: event,
            addModalOpen: true
        });
    }

    saveEvents() {
        return new Promise((resolve) => {
            let events = this.state.events.map((event) => {
                let eventCopy = { ...event };
                eventCopy.start = moment(event.start)
                    .format("YYYY-MM-DD HH:mm:ss");
                eventCopy.end = moment(event.end)
                    .format("YYYY-MM-DD HH:mm:ss");
                return eventCopy;
            });
            this.props.saveEvents(this.state.loaded_warehouse_id, events)
                .then(() => {
                    this.reloadEvents()
                        .then(() => {
                            resolve();
                        });
                });
        });

    }


    componentWillMount() {

        this.props.loadClock()
            .then(() => {
                this.props.loadEmployees();
            });

    }

    deleteEvent(pEvent) {
        const r = window.confirm("Would you like to remove this event?");
        if (r === true) {

            this.setState((prevState, props) => {
                const events = [...prevState.events];
                events.map((event) => {
                    if (event.id === pEvent.id) {
                        event.delete = true;
                    }
                    return event;
                });
                return { events };
            });
        }
    }

    onSelectEvent(pEvent) {

        this.setState({
            selectedEvent: pEvent,
            detailModalOpen: true
        });

    }

    render() {


        return (
            <div>
                <Dimmer active={this.props.loading}>
                    <Loader>Loading</Loader>
                </Dimmer>
                <Segment stacked>

                    <WarehouseSelect
                        value={this.state.warehouse_id}
                        onChange={(warehouse_id) => {
                            this.setState({ warehouse_id });
                        }}
                    />
                    <div>{this.state.warehouse_id && <Button color='green' onClick={
                        () => {
                            this.reloadEvents();
                        }
                    } inverted>
                        <Icon name='search'/> Load
                    </Button>}</div>

                </Segment>
                {this.state.loaded && <Segment>


                    <div style={{ minHeight: "100vh" }}>

                        <BigCalendar
                            selectable
                            style={{ minHeight: "100vh" }}
                            localizer={localizer}
                            defaultView={"week"}
                            view={this.state.view}
                            onView={(view) => {
                                this.setState({ view });
                            }}
                            min={this.state.minTime}
                            events={this.state.events}
                            date={this.state.dayChosen}
                            defaultDate={new Date()}
                            eventPropGetter={(event) => {
                                if (event.delete) {
                                    return { style: { display: "none !important" } };
                                }
                                if (event.activity_id in activityColors) {
                                    return { style: { backgroundColor: activityColors[event.activity_id] } };
                                }
                            }}
                            onNavigate={(focusDate, flipUnit, prevOrNext) => {

                                let date = moment(focusDate);

                                if (date.diff(this.state.minDate) > 0 && date.diff(this.state.maxDate) < 0) {
                                    this.setState({
                                        dayChosen: date.toDate()
                                    });
                                }
                            }}

                            messages={{
                                allDay: "ganzer Tag",
                                previous: "Vorherige",
                                next: "Nächste",
                                today: "Heute",
                                month: "Monat",
                                week: "Woche",
                                day: "Tag",
                                agenda: "Agenda",
                                date: "Datum",
                                time: "Stunde",
                                event: "Eintrag", // Or anything you want
                                showMore: total => `+ ${total} weitere Einträge`
                            }}
                        />
                    </div>
                </Segment>
                }

                {this.state.loaded && this.state.events.length > 0 && <Segment>
                    <Header>Zusammenfassung:</Header>
                    {Schedule.getSummary(this.state.dayChosen, this.state.view, this.state.events, this.props.activities, this.props.employees)}
                </Segment>}
            </div>

        );

    }

}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    employees: getEmployees(state),
    activities: getActivities(state),
    events: getEvents(state),
    loading: isLoading(state)
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    };
}

const mapDispatchToProps = (dispatch) => {
    return ({
        loadClock: () => (dispatch(loadClock())),
        loadEmployees: () => (dispatch(loadEmployees())),
        loadEvents: (warehouse, start, end) => (dispatch(loadEvents(warehouse, start, end))),
    });
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ScheduleView);



// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/ScheduleView/index.js